import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import BasicCard from "../../../components/basics/cards/BasicCard"
import NodeListing from "./NodeListing"
import ManageNode from "./ManageNode"
import '../../../components/layout/layout.css'
import '../../../css/administration.css'

export default function Nodes() {
    return (
        <BasicCard cardConfig={{ cardTitle: 'Node administration', cardHeadingElement: 'h4' }}>
            <Tabs defaultActiveKey='create-edit' id='node-admin-tabs' className='mb-3'>
                <Tab eventKey='create-edit' title='Create/Edit Node'>
                    <NodeListing />
                </Tab>
                <Tab eventKey='manage' title='Manage Node'>
                    <ManageNode />
                </Tab>
            </Tabs>
        </BasicCard>
    )
}
